// extracted by mini-css-extract-plugin
module.exports = {"header":"index-module--header--2-EPR","heading":"index-module--heading--2Qe10"};